<div class="course-supplement" [ngClass]="{ 'course-supplement--selected': supplementSelected }">
  <div class="course-supplement__actions">
    <ng-container *ngIf="isMultiSelect; else singleSelect">
      <ng-template [ngTemplateOutlet]="multiSelect"></ng-template>
    </ng-container>
  </div>
  <div class="course-supplement__details">
    <div class="course-supplement__details-row">
      <div class="course-supplement__details-text">
        <span>{{ supplement.name }}</span>
        <ng-container *ngIf="supplement | lxSupplementDurationUnit as durationUnit">
          <span> ({{ durationUnit }})</span>
        </ng-container>
        <ng-container *ngIf="showDescription && supplement.description">
          <br /><span class="course-supplement__details-description">{{ supplement.description }}</span>
        </ng-container>
      </div>
      <div class="course-supplement__details-price">
        <ng-container *ngIf="!optionalsExist(); else emptyPriceSlot">
          <ng-container *ngIf="!supplement?.priceOnRequest; else supplementPriceRequest">
            <div *ngIf="supplement?.price" class="course-supplement__price">{{ supplement.price | lxPrice : { currency: displayCurrency() } }}</div>
          </ng-container>
          <ng-template #supplementPriceRequest>
            <div i18n class="course-supplement__on-request">On request</div>
          </ng-template>
        </ng-container>
        <ng-template #emptyPriceSlot></ng-template>
      </div>
    </div>
    <ng-container *ngIf="supplement?.availableDates?.periods?.length">
      <span class="course-supplement__details-dates">
        <ng-container *ngFor="let availableDate of supplement.availableDates.periods; let first = first; let last = last">
          {{ first ? '(' : '' }}{{ availableDate.from | lxDate : DateFormat.NUMBERS_ONLY }} - {{ availableDate.until | lxDate : DateFormat.NUMBERS_ONLY
          }}{{ !last ? ', ' : ')' }}
        </ng-container>
      </span>
      <br />
      <ng-container [ngSwitch]="availabilityStatus">
        <span i18n class="course-supplement__details-dates-warning" *ngSwitchCase="AvailabilityStatus.NOT_AVAILABLE">Not available during your stay</span>
        <span i18n class="course-supplement__details-dates-warning" *ngSwitchCase="AvailabilityStatus.PARTIALLY_AVAILABLE"
          >Partially available during your stay</span
        >
      </ng-container>
    </ng-container>

    <div *ngIf="optionalsExist()" class="course-supplement__optional-summary">
      <div class="course-supplement__optional-summary-duration">
        <span class="course-supplement__optionals-duration">{{ firstOptional() | lxOptionalPriceDuration }} {{ firstOptional()?.label }} </span>
      </div>
      <div class="course-supplement__optional-summary-price">
        <span class="course-supplement__price-value">{{ firstOptional()?.price | lxPrice : { currency: displayCurrency() } }}</span>
      </div>
    </div>

    <button
      *ngIf="multipleOptionalsExist()"
      type="button"
      class="course-supplement__optionals-toggle"
      (click)="toggleOptionsExpansion()"
      [attr.aria-expanded]="optionsExpanded()"
    >
      <span i18n class="course-supplement__optionals-toggle-label">{{ toggleOptionsLabel() }}</span>
      <span class="course-supplement__optionals-toggle-icon" aria-hidden="true">
        <i [ngClass]="optionsExpanded() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
      </span>
    </button>

    <div *ngIf="optionsExpanded()" class="course-supplement__optionals-panel">
      <div *ngFor="let optional of remainingOptionals()" class="course-supplement__optionals-row course-supplement__optionals-row--secondary">
        <span class="course-supplement__optionals-duration">{{ optional | lxOptionalPriceDuration }} {{ optional.label }}</span>
        <span class="course-supplement__optionals-price">{{ optional.price | lxPrice : { currency: displayCurrency() } }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #singleSelect>
  <div class="course-supplement__single-select">
    <span
      class="course-supplement__action-icon"
      [ngClass]="{ 'course-supplement__action-icon--disabled': disabled }"
      (click)="toggleSelected()"
      [@addOrRemove]="supplementSelected ? 'remove' : 'add'"
    >
      <i class="pi pi-plus"></i>
    </span>
  </div>
</ng-template>

<ng-template #multiSelect>
  <div class="course-supplement__multi-select">
    <ng-container *ngIf="supplementSelected">
      <div class="course-supplement__action-icon" (click)="removeSupplement()" [@showOrHide]="supplementSelected ? 'show' : 'hide'">
        <i class="pi pi-minus"></i>
      </div>
      <div class="course-supplement__quantity" [@showOrHide]="supplementSelected ? 'show' : 'hide'">
        {{ quantity }}
      </div>
    </ng-container>

    <div
      class="course-supplement__action-icon"
      (click)="!expired && addSupplement()"
      [ngClass]="{ 'course-supplement__action-icon--disabled': !canSelectSupplement || expired || quantity >= supplement.maxUnit }"
    >
      <i class="pi pi-plus"></i>
    </div>
  </div>
</ng-template>
